import Menu from "./menu.molecule";

export default Menu;
